module.exports = __webpack_public_path__ + "img/video-thumb-1.a5635b16.png";